import api from "../api";

export const getTasks = async (filters = {}) => {
  return api.getApi().get(api.getBaseUrl() + "tasks", { params: filters });
};

export const getTask = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `tasks/${id}`);
};

export const createTask = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "tasks", data);
};

export const updateTask = async (id, data) => {
  return api.getApi().put(api.getBaseUrl() + `tasks/${id}`, data);
};

export const deleteTask = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `tasks/${id}`);
};
